import React from "react";

export default function PageHeader({ title, subtitle, right, helpText }) {
  return (
    <div className="bg-white border-b border-[#EEEEEE] no-print" data-testid="page-header">
      <div className="px-8 py-5 flex items-end justify-between">
        <div>
          <div className="text-[10px] tracking-[0.2em] text-[#1565C0] font-bold uppercase mb-1">SUPPLAR / {title}</div>
          <h1 className="text-2xl font-bold text-[#0D2B5E]">{title}</h1>
          {subtitle && <div className="text-sm text-[#0D2B5E]/70 mt-1">{subtitle}</div>}
        </div>
        {right && <div className="flex items-center gap-2">{right}</div>}
      </div>
      {helpText && (
        <div className="px-8 py-2 bg-[#1565C0]/5 border-t border-[#1565C0]/20 text-xs text-[#0D2B5E] flex items-start gap-2" data-testid="page-help">
          <span className="text-[#1565C0] font-bold">i</span>
          <span>{helpText}</span>
        </div>
      )}
    </div>
  );
}
